import { cva } from 'class-variance-authority'
// import { useEffect, useState } from 'react'
import {
  CarouselNext,
  CarouselPrevious,
  CarouselDots
} from '~/components/UI/shadcn/carousel'
// import { useDebounce } from '~/hooks/useDebounce'
import { cn } from '~/lib/utils'

type Controls = {
  current: number
  count: number
  colour: 'ink-blue' | 'mid-blue' | 'light-blue' | 'white' | null | undefined
  // eslint-disable-next-line @typescript-eslint/ban-types
  setCurrent: Function
}

const componentColour = cva('flex gap-[28px] flex-wrap', {
  variants: {
    colour: {
      'ink-blue':
        '[&_button]:bg-blue-d text-blue-d [&_button]:stroke-white fill-blue-d [&_button]:fill-white [&_input]:hover:border-blue-d [&_input]:focus:border-blue-d',
      'mid-blue':
        '[&_button]:bg-blue-m text-blue-m [&_button]:stroke-white fill-blue-m [&_button]:fill-black [&_input]:hover:border-blue-d [&_input]:focus:border-blue-d',
      'light-blue':
        '[&_button]:bg-blue-l text-blue-l [&_button]:stroke-blue-d fill-blue-l [&_button]:fill-white [&_input]:hover:border-white [&_input]:focus:border-white',
      white:
        '[&_button]:bg-white text-white [&_button]:stroke-blue-d fill-white [&_button]:fill-black [&_input]:hover:border-white [&_input]:focus:border-white'
    }
  },
  defaultVariants: {
    colour: 'ink-blue'
  }
})

const CarouselControls = (data: Controls) => {
  // const [inputValue, setInputValue] = useState<string>('')
  // const debouncedValue = useDebounce(data?.current, 400)

  const colour = data?.colour

  // useEffect(() => {
  //   setInputValue(
  //     data?.current.toLocaleString(undefined, {
  //       minimumIntegerDigits: 2
  //     })
  //   )
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [data?.current])

  return (
    <div className={cn(componentColour({ colour }))}>
      {data?.count > 5 ? (
        <div className='self-center font-mono text-sm'>
          {data?.current.toLocaleString(undefined, {
            minimumIntegerDigits: 2
          })}
          {/* <input
            className='h-s w-s border-blue-d-40 border bg-transparent p-[2px] transition-colors'
            value={inputValue}
            onFocus={() => {
              setInputValue('')
            }}
            onBlur={() => {
              setInputValue(
                data?.current.toLocaleString(undefined, {
                  minimumIntegerDigits: 2
                })
              )
            }}
            onChange={e => {
              if (
                parseInt(e.target.value) <= data?.count &&
                parseInt(e.target.value) > 0
              ) {
                data?.setCurrent(parseInt(e.target.value))
              } else {
                setInputValue(
                  data?.current.toLocaleString(undefined, {
                    minimumIntegerDigits: 2
                  })
                )
              }
            }}
            onKeyDown={() => {
              // setInputValue('')
            }}
          /> */}
          /
          {data?.count.toLocaleString(undefined, {
            minimumIntegerDigits: 2
          })}
        </div>
      ) : (
        <CarouselDots className='gap-2xs-plus items-center' />
      )}
      <div className='space-x-2xs hover:bg-none'>
        <CarouselPrevious
          variant='default'
          className='disabled:bg-grey-m disabled:stroke-blue-d relative left-0 border-none hover:bg-current disabled:opacity-100'
        />
        <CarouselNext
          variant='default'
          className='disabled:bg-grey-m disabled:stroke-blue-d relative left-0 border-none hover:bg-current disabled:opacity-100'
        />
      </div>
    </div>
  )
}

export default CarouselControls
